(function() {
  // US ZIP code validation regex (5 digits or 5+4 format)
  const US_ZIPCODE_REGEX = /^\d{5}(-\d{4})?$/;
  
  // Cache for US holidays and ZIP lookups
  let usHolidaysCache = null;
  let zipLookupCache = {};
  
  // Format date for display (US format)
  function formatDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    const suffix = (day === 1 || day === 21 || day === 31) ? 'st' : 
                  (day === 2 || day === 22) ? 'nd' : 
                  (day === 3 || day === 23) ? 'rd' : 'th';
    return days[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + day + suffix;
  }
  
  // Format price for display
  function formatPrice(price) {
    const amount = parseFloat(price);
    if (amount === 0) {
      return 'FREE';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }
  
  // Add days to date
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  
  // Check if date is Sunday/Saturday
  function isSunday(date) { return date.getDay() === 0; }
  function isSaturday(date) { return date.getDay() === 6; }
  
  // Format date for holiday check
  function formatDateForHolidayCheck(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }
  
  // Check if date is US holiday
  function isUSHoliday(date, holidays) {
    return holidays.includes(formatDateForHolidayCheck(date));
  }
  
  // Fetch US holidays
  async function getUSHolidays(year) {
    if (usHolidaysCache) return usHolidaysCache;
    
    try {
      const response = await fetch('https://date.nager.at/api/v3/publicholidays/' + year + '/us');
      const data = await response.json();
      usHolidaysCache = data.map(function(h) { return h.date; });
      return usHolidaysCache;
    } catch (error) {
      console.error('Error fetching US holidays:', error);
      return [];
    }
  }
  
  // Lookup state from ZIP code using Zippopotam.us API
  async function getStateFromZip(zipcode) {
    const zip5 = zipcode.substring(0, 5);
    
    if (zipLookupCache[zip5]) {
      return zipLookupCache[zip5];
    }
    
    try {
      const response = await fetch('https://api.zippopotam.us/us/' + zip5);
      
      if (!response.ok) {
        return { error: 'Invalid ZIP code', state: null, city: null };
      }
      
      const data = await response.json();
      
      if (data.places && data.places.length > 0) {
        const result = {
          error: null,
          state: data.places[0]['state abbreviation'],
          stateName: data.places[0]['state'],
          city: data.places[0]['place name']
        };
        zipLookupCache[zip5] = result;
        return result;
      }
      
      return { error: 'ZIP code not found', state: null, city: null };
    } catch (error) {
      console.error('Error looking up ZIP code:', error);
      return { error: 'Unable to lookup ZIP code', state: null, city: null };
    }
  }
  
  // Check if cart has items
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
  
  // Fetch shipping rates from Shopify
  async function getShippingRates(zipcode, state) {
    try {
      const params = new URLSearchParams({
        'shipping_address[zip]': zipcode,
        'shipping_address[country]': 'US',
        'shipping_address[province]': state
      });
      
      const url = '/cart/shipping_rates.json?' + params.toString();
      const response = await fetch(url);
      
      if (response.status === 422) {
        const errorData = await response.json();
        return { error: 'validation_error', message: errorData, rates: [] };
      }
      
      if (!response.ok) {
        return { error: 'api_error', rates: [] };
      }
      
      const data = await response.json();
      return { error: null, rates: data.shipping_rates || [] };
    } catch (error) {
      console.error('Error fetching shipping rates:', error);
      return { error: 'fetch_error', rates: [] };
    }
  }
  
  // Calculate delivery dates
  function calculateDeliveryDates(usHolidays, deliveryDaysMin, deliveryDaysMax) {
    var businessDaysToAdd = deliveryDaysMax - deliveryDaysMin;
    
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    
    var fromDate = addDays(today, deliveryDaysMin);
    
    function adjustDate(date) {
      var adjusted = new Date(date);
      var count = 0;
      while (isSaturday(adjusted) || isSunday(adjusted) || isUSHoliday(adjusted, usHolidays)) {
        adjusted = addDays(adjusted, 1);
        count++;
        if (count > 14) break;
      }
      return adjusted;
    }
    
    fromDate = adjustDate(fromDate);
    var toDate = new Date(fromDate);
    
    while (businessDaysToAdd > 0) {
      toDate = addDays(toDate, 1);
      if (!isSaturday(toDate) && !isSunday(toDate) && !isUSHoliday(toDate, usHolidays)) {
        businessDaysToAdd--;
      }
    }
    
    return { fromDate: fromDate, toDate: toDate };
  }
  
  // Validate US ZIP code
  function isValidUSZipcode(zipcode) {
    return US_ZIPCODE_REGEX.test(zipcode.trim());
  }
  
  // Get CSS class prefix based on context
  function getClassPrefix(wrapper) {
    if (wrapper.classList.contains('cart-page-shipping-calculator')) {
      return 'cart-page-shipping-calculator';
    }
    return 'shipping-calculator';
  }
  
  // Render shipping rates
  function renderShippingRates(rates, holidays, container, locationInfo, classPrefix) {
    if (!rates || rates.length === 0) {
      container.innerHTML = '<p class="' + classPrefix + '__no-rates">No shipping options available for this location.</p>';
      return;
    }
    
    var html = '';
    
    if (locationInfo) {
      html += '<div class="' + classPrefix + '__location">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>' +
        '<span>' + locationInfo.city + ', ' + locationInfo.stateName + '</span>' +
      '</div>';
    }
    
    html += '<div class="' + classPrefix + '__rates">';
    
    rates.forEach(function(rate, index) {
      var price = formatPrice(rate.price);
      var name = rate.name;
      
      var deliveryDaysMin = rate.delivery_days ? parseInt(rate.delivery_days) : 3;
      var deliveryDaysMax = rate.delivery_days ? parseInt(rate.delivery_days) + 2 : 7;
      
      var nameLower = name.toLowerCase();
      if (nameLower.includes('express') || nameLower.includes('priority') || nameLower.includes('expedited')) {
        deliveryDaysMin = 1; deliveryDaysMax = 3;
      } else if (nameLower.includes('overnight') || nameLower.includes('next day')) {
        deliveryDaysMin = 1; deliveryDaysMax = 1;
      } else if (nameLower.includes('2-day') || nameLower.includes('two day') || nameLower.includes('2 day')) {
        deliveryDaysMin = 2; deliveryDaysMax = 2;
      } else if (nameLower.includes('standard') || nameLower.includes('ground')) {
        deliveryDaysMin = 5; deliveryDaysMax = 7;
      } else if (nameLower.includes('economy') || nameLower.includes('slow')) {
        deliveryDaysMin = 7; deliveryDaysMax = 10;
      } else if (nameLower.includes('free')) {
        deliveryDaysMin = 5; deliveryDaysMax = 10;
      }
      
      var dates = calculateDeliveryDates(holidays, deliveryDaysMin, deliveryDaysMax);
      var fromDate = dates.fromDate;
      var toDate = dates.toDate;
      
      var rateClass = classPrefix + '__rate';
      if (index === 0) rateClass += ' ' + classPrefix + '__rate--first';
      
      var priceClass = classPrefix + '__rate-price';
      if (parseFloat(rate.price) === 0) priceClass += ' ' + classPrefix + '__rate-price--free';
      
      var dateText = formatDate(fromDate);
      if (deliveryDaysMin !== deliveryDaysMax) {
        dateText += ' - ' + formatDate(toDate);
      }
      
      html += '<div class="' + rateClass + '">' +
        '<div class="' + classPrefix + '__rate-info">' +
          '<span class="' + classPrefix + '__rate-name">' + name + '</span>' +
          '<span class="' + classPrefix + '__rate-dates">' + dateText + '</span>' +
        '</div>' +
        '<span class="' + priceClass + '">' + price + '</span>' +
      '</div>';
    });
    
    html += '</div>';
    container.innerHTML = html;
  }
  
  // Render estimated delivery only (fallback)
  function renderEstimatedDelivery(holidays, container, message, locationInfo, classPrefix) {
    var dates = calculateDeliveryDates(holidays, 3, 7);
    var fromDate = dates.fromDate;
    var toDate = dates.toDate;
    var html = '';
    
    if (locationInfo) {
      html += '<div class="' + classPrefix + '__location">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>' +
        '<span>' + locationInfo.city + ', ' + locationInfo.stateName + '</span>' +
      '</div>';
    }
    
    html += '<div class="' + classPrefix + '__dates">' +
      '<span class="' + classPrefix + '__label">Estimated delivery:</span>' +
      '<span class="' + classPrefix + '__date-range">' + formatDate(fromDate) + ' - ' + formatDate(toDate) + '</span>';
    
    if (message) {
      html += '<small class="' + classPrefix + '__note">' + message + '</small>';
    }
    
    html += '</div>';
    
    container.innerHTML = html;
  }
  
  // Initialize a single calculator instance
  function initCalculatorInstance(wrapper) {
    var input = wrapper.querySelector('#shipping-postcode');
    var btn = wrapper.querySelector('#calculate-shipping-btn');
    var result = wrapper.querySelector('#shipping-result');
    var error = wrapper.querySelector('#shipping-error');
    var resultsWrapper = wrapper.querySelector('#shipping-calculator-content');
    
    if (!input || !btn) return;
    
    // Mark as initialized to prevent duplicate handlers
    if (wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';
    
    var classPrefix = getClassPrefix(wrapper);
    var isDrawer = wrapper.classList.contains('shipping-calculator--drawer');
    
    // Handle calculate click
    btn.addEventListener('click', async function() {
      var zipcode = input.value.trim();
      
      // Hide previous results/errors
      if (result) result.style.display = 'none';
      if (error) error.style.display = 'none';
      if (resultsWrapper && isDrawer) resultsWrapper.style.display = 'none';
      
      // Validate ZIP code
      if (!zipcode) {
        if (error) {
          error.textContent = 'Please enter a ZIP code';
          error.style.display = 'block';
        }
        return;
      }
      
      if (!isValidUSZipcode(zipcode)) {
        if (error) {
          error.textContent = 'Please enter a valid US ZIP code (e.g., 90210)';
          error.style.display = 'block';
        }
        return;
      }
      
      // Show loading state
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Calculating...';
      
      try {
        // First, lookup the state from ZIP code
        var zipInfo = await getStateFromZip(zipcode);
        
        if (zipInfo.error || !zipInfo.state) {
          if (error) {
            error.textContent = 'Invalid ZIP code. Please check and try again.';
            error.style.display = 'block';
          }
          btn.disabled = false;
          btn.textContent = originalText;
          return;
        }
        
        // Fetch holidays, cart data, and shipping rates
        var results = await Promise.all([
          getUSHolidays(new Date().getFullYear()),
          getCartData(),
          getShippingRates(zipcode, zipInfo.state)
        ]);
        
        var holidays = results[0];
        var cart = results[1];
        var shippingData = results[2];
        
        // Check if cart is empty
        if (!cart || cart.item_count === 0) {
          renderEstimatedDelivery(holidays, result, 'Add items to cart to see shipping rates.', zipInfo, classPrefix);
          if (result) result.style.display = 'block';
          if (resultsWrapper && isDrawer) {
            resultsWrapper.style.display = 'block';
            resultsWrapper.classList.remove('is-collapsed');
          }
          return;
        }
        
        // Handle different scenarios
        if (shippingData.error || shippingData.rates.length === 0) {
          renderEstimatedDelivery(holidays, result, 'Exact shipping cost will be shown at checkout.', zipInfo, classPrefix);
        } else {
          renderShippingRates(shippingData.rates, holidays, result, zipInfo, classPrefix);
        }
        
        if (result) result.style.display = 'block';
        if (resultsWrapper && isDrawer) {
          resultsWrapper.style.display = 'block';
          resultsWrapper.classList.remove('is-collapsed');
        }
      } catch (err) {
        console.error('Shipping calculator error:', err);
        if (error) {
          error.textContent = 'Unable to calculate shipping. Please try again.';
          error.style.display = 'block';
        }
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    });
    
    // Handle enter key
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        btn.click();
      }
    });
  }
  
  // Initialize all calculators on page
  function initShippingCalculators() {
    var wrappers = document.querySelectorAll('#shipping-calculator-wrapper');
    wrappers.forEach(function(wrapper) {
      initCalculatorInstance(wrapper);
    });
  }
  
  // Global event delegation for toggle (survives innerHTML updates)
  function setupGlobalToggleListener() {
    document.addEventListener('click', function(e) {
      var toggleBtn = e.target.closest('.shipping-calculator__results-toggle');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        var resultsWrapper = toggleBtn.closest('.shipping-calculator__results-wrapper');
        if (resultsWrapper) {
          var shippingResult = resultsWrapper.querySelector('#shipping-result, .shipping-calculator__result');
          var isCollapsed = resultsWrapper.classList.contains('is-collapsed');
          
          if (isCollapsed) {
            // Expand
            resultsWrapper.classList.remove('is-collapsed');
            toggleBtn.setAttribute('aria-expanded', 'true');
            if (shippingResult) shippingResult.style.display = 'block';
          } else {
            // Collapse
            resultsWrapper.classList.add('is-collapsed');
            toggleBtn.setAttribute('aria-expanded', 'false');
            if (shippingResult) shippingResult.style.display = 'none';
          }
        }
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initShippingCalculators();
      setupGlobalToggleListener();
    });
  } else {
    initShippingCalculators();
    setupGlobalToggleListener();
  }
  
  // Re-initialize when cart is updated (Shopify cart drawer updates innerHTML)
  document.addEventListener('cart:updated', initShippingCalculators);
  
  // Also observe for DOM changes in cart drawer (fallback)
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          var hasCalculator = false;
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              if (node.id === 'shipping-calculator-wrapper') {
                hasCalculator = true;
                break;
              }
              if (node.querySelector && node.querySelector('#shipping-calculator-wrapper')) {
                hasCalculator = true;
                break;
              }
            }
          }
          if (hasCalculator) {
            initShippingCalculators();
            break;
          }
        }
      }
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
})();
